
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:50px;">   

         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   医院汇款认领
                </span>
                <span class="ml-5">
                              <span>查询时间从 
                                              <span class="yanse" style="font-size:15px;">
                                                      {{searchForm.DateLessThan | chaxunDate}}
                                                </span>
                                                      到
                                                <span class="yanse" style="font-size:15px;">
                                                        {{searchForm.DateMoreThan | chaxunDate1}}
                                                </span>
                              </span>
                </span>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>


              <div class="mb-2" style="margin-left:20px;display:flex;align-items:center;font-size:15px;">
                    <span>电子回单号码:</span>
                    <input type="text" class="input_form-control ml-2" v-model="searchForm.EbankReceiptNum">
                    <span class="ml-2">付方账户名称:</span>
                    <input type="text" class="input_form-control ml-2" v-model="searchForm.PayAccountName">
                    <span class="ml-2">银行名称:</span>
                    <input type="text" class="input_form-control ml-2" v-model="searchForm.CollectionDepositBankName">
                    <span>交易金额:</span>
                    <input type="text" class="input_form-control ml-2" v-model="searchForm.DealMoney">
                    <span class="ml-3 mr-2">查询日期:</span>
                        <date3 @changeDate="changeDate1($event)"/>
                    <span class="ml-3 mr-2">到:</span>
                        <date @changeDate="changeDate2($event)"/>
                     <button class="bg-primary button_zi heit ml-4" @click="getClerkStoreGoodsQuery()">
                         查询
                    </button>
              </div>

                                  <div v-if="showPage">
                                               <table  class="table table-striped table-hover">
                                                        <thead>
                                                            <tr style="white-space: nowrap;" class="text-center">
                                                                <th>电子回单号码</th>
                                                                <th>付方账户名称</th>
                                                                <th>银行名称</th>
                                                                <th>交易金额</th>
                                                                <th>汇款日期</th>
                                                                <th>认领状态</th>
                                                                <th>备注</th>
                                                                <th>操作</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in tableData" :key="index" >
                                                                 <td class="jz_middle">{{item.ebankReceiptNum}}</td>
                                                                 <td class="jz_middle">{{item.payAccountName}}</td>
                                                                 <td class="jz_middle">
                                                                   {{item.collectionDepositBankName}}
                                                                  </td>
                                                                 <td class="jz_middle">
                                                                    {{item.dealMoney}}
                                                                 </td>
                                                                 <td class="jz_middle">{{item.dealDate | formatUTC}}</td>
                                                                 <td class="jz_middle">{{item.claimState}}</td>
                                                                 <td class="jz_middle">{{item.remark}}</td>
                                                                <td class="jz_middle">
                                                                         <button class="bg-primary button_zi heit" @click="claim(index)">
                                                                             认领
                                                                         </button>
                                                                </td>
                                                             </tr>
                                                        </tbody>
                                                    </table>
                                                    <div>
                                                          <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                                                    </div>

                                         </div>


                  <div v-else>

                       <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>

               

                <p class="text-center">
                    <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>


       </div> 



      </div>

       <!-- 弹框弹出内容 -->
               
                       <div class="modal fade" id="chaxun" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:1200px;position:relative;top:50px;left:-150px;">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                          <div class="card-header">
                                               <div class="font">
                                                   {{searchForm.CustomerName}}
                                               </div>
                                          </div>
                                          <div class="card-body">
                                               <!-- <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="客户名称" v-model="searchForm.CustomerName" @keydown.enter="searchEnterFun1">
                                                    <button class="ml-lg-2 btn btn-primary" @click="clerksettlementsupplierquery()">
                                                        搜索
                                                    </button>
                                               </div> -->
                                               <div v-if="showChaxun">
                                                        <table class="table table-striped table-hover">
                                                        <thead>
                                                            <tr style="white-space: nowrap;" class="text-center">
                                                                <th>姓名</th>
                                                                <th>身份证号</th>
                                                                <th>备注</th>
                                                                <th>操作</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in supplierList" :key="index">
                                                                 <td class="jz_middle">{{item.busiManName}}</td>
                                                                 <td class="jz_middle">{{item.busiManIDNumber}}</td>
                                                                <td class="jz_middle">
                                                                      <input type="text" v-model="item.value">
                                                                </td>
                                                                 <td  class="jz_middle">
                                                                     <button class="btn btn-success" style="font-size:12px;" @click="getCode1(index)">
                                                                         确定
                                                                     </button>
                                                                 </td>
                                                             </tr>
                                                        </tbody>
                                                    </table>
                                               
                                               </div>

                                               <div v-else>
                                                     <p style="font-size:18px;color:red;">
                                                        请先到战略部进行医院汇款单位设置！
                                                     </p>
                                               </div>
                                          </div>
                                                 
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                            </div>
                            </div>
                        </div>
                    </div>

        
     




    <!-- 详情内容 -->

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>


                 <!-- 弹窗内容 -->



     </div>
</template>
<script>
import date from '../components/Date.vue'
import date3 from '../components/Date3.vue'
import vPagination from "../components/Pagination.vue"
import Loading from '../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          EbankReceiptNum:"",
          PayAccountName:"",
          CollectionDepositBankName:"",
          DateMoreThan: '',
          DateLessThan: '' ,
          DateLessThan1: '',
          DateMoreThan1: '',
          CustomerName:'',
          DealMoney:'',
        
        },//搜索内容
        isLoading: false,
        tableData: [],
        showPage:false,
        totalLimitMoney:'',

           total:1,     // 记录总条数
           display: 20,   // 每页显示条数
           current: 1,   // 当前的页数

             total1:1,     // 记录总条数
            display1: 20,   // 每页显示条数
            current1: 1,   // 当前的页数

         showVue:false,
         showChaxun:true,

         supplierList:[],

         BusiManName:"",
         BusiManIDNumber:"",
         Remark:"",

         id:"",
        

      }
    },
    components:{
        vPagination,
        Loading,
        date,
        date3,
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        status:function(status){
          if(status==0){
            return "不限制"
          }
          else if(status==1)
          {
            return "限制"
          }
        },
            chaxunDate(date){
           let change_date=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
           return change_date+" 00:00:00"
      },
      chaxunDate1(date){
         let time_change=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
        let year=new Date(new Date(time_change).getTime()-24*60*60*1000).getFullYear();

        let month=new Date(new Date(time_change).getTime()-24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(time_change).getTime()-24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=year+"-"+month+"-"+time_date;
                     }
                  }

         let change_date=time;
           return change_date+" 23:59:59"
      }
},

methods: {

 searchEnterFun1(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.clerksettlementsupplierquery();
         }
      },
 

  //确定认领
   getCode1(index){
        this.BusiManName=this.supplierList[index].busiManName
        this.BusiManIDNumber = this.supplierList[index].busiManIDNumber
        this.Remark = this.supplierList[index].value
        
        this.Clerkebankreceipthospitalclaim()

   },

//弹框
claim(index){
       this.searchForm.CustomerName=this.tableData[index].payAccountName;
       this.clerksettlementsupplierquery();
       $('#chaxun').modal();
       this.id=this.tableData[index].iD;

},


     pagechange:function(currentPage){
        
           this.getClerkStoreGoodsQuery(currentPage);
         
     },
      pagechange1:function(currentPage){
        
           this.clerksettlementsupplierquery(currentPage);
         
     },
  
          
           getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
             getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
               return tYear + "" + tMonth + "" + tDate;
            },
  
          //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
          this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },

     

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.clerksettlementsupplierquery();
         }
      },
      

  //确认认领
    Clerkebankreceipthospitalclaim: async function () {
          // this.isLoading=true;
          const that = this;
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'Clerkebankreceipthospitalclaim',
          obj: JSON.stringify({

               EbankReceiptID:that.id,
               BusiManName:that.BusiManName,
               BusiManIDNumber:that.BusiManIDNumber,
               Remark:that.Remark,   
          }) 
        })
        // console.log(res)
        if (res.isok) {
                    if(res.data.isSucceed)
                    {
                          $('#chaxun').modal("hide");
                          that.$message.success("认领成功!")

                    }
                    else{
                      alert(res.data.msg)
                    }

               }

    },

      

       //医院汇款认领人查询
    clerksettlementsupplierquery: async function (PageIndex) {
          // this.isLoading=true;
          const that = this;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'Clerkebankreceipthospitalclaimerquery',
          obj: JSON.stringify({
               PageIndex,
            
              CustomerName:that.searchForm.CustomerName,
          }) 
        })
        // console.log(res)
        if (res.isok) {
                    const obj = res.data
                    this.supplierList = obj.rows
                  if(this.supplierList.length>0)
                 {
                    that.showChaxun=true;
                 }
                 else{
                    that.showChaxun=false;
                 }
                    this.total1 = obj.record
               }

    },

      
        
    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {
          // this.isLoading=true;
          const that = this;
          let reg =/^([1-9][0-9]*)(\.\d+)?$/;
          let  threeMonth=that.getDay(-3*30);
        
        let  threeMonthTime=new Date(threeMonth).getTime()
        
        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();
       
        let  select=that.searchForm.DateLessThan1;
       
        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();
       
        let  seTime2=new Date(select1).getTime();

        let ces=that.searchForm.DateLessThan;
        let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else if(that.searchForm.DealMoney==""){
            alert("交易金额不能为空")
        }
        else if(!reg.test(that.searchForm.DealMoney)){
            alert("交易金额为不是零的正数")
        }
        else{
           
        if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'Clerkebankreceiptquery',
          obj: JSON.stringify({
             PageIndex,
             EbankReceiptNum:that.searchForm.EbankReceiptNum,
             PayAccountName:that.searchForm.PayAccountName,
             CollectionDepositBankName:that.searchForm.CollectionDepositBankName,
             DealMoney:that.searchForm.DealMoney,
             DateMoreThan:that.searchForm.DateLessThan,
             DateLessThan:that.searchForm.DateMoreThan,
           
          }) 
        })
        // console.log(res)
           if(res.isok){
                // that.showVue=true;
                const obj=res.data
                that.tableData = obj.rows
                that.total = obj.record
                // that.total = obj.Rcount
                if(this.tableData.length>0)
                {
                    that.showPage=true;
                }
                else{
                    that.showPage =false;
                }

             
           }

                    
          }
          else{
            alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          }
          


        }
         
      },
  
    },
     mounted(){
    },
     created () {
          this.searchForm.DateMoreThan=this.getDay1(1)
          this.searchForm.DateLessThan=this.getDay1(-7)
          this.searchForm.DateLessThan1=this.getDay(-8)
          this.searchForm.DateMoreThan1=this.getDay(0)
          // this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
   text-align:center;
 }
.input_form-control {
/* // display: block;  */
width: 10%; 
height: 24px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
.table_chuang{
  width:1000px;
  height:400px;
  margin:0 auto;
}
.yanse{
  color:red;
}
</style>


// WEBPACK FOOTER //
// src/pages/HospitalMoney.vue